import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchDiaryInfo, showMoreCalendarView, resetViewDiaryInfo } from "../../Diaries/actions";
import Icons from "../../../icons";
import { showDialogueBox, hideDialogueBox } from "../../../components/DialogueBox/actions";
import DiaryDetailPopUp from '../../../components/DiaryDetailPopUp';
import { hideTooltip } from '../../SpockViewPage/actions/action';
import { getActivityDetail,getWorkkardDetailMasterData } from "../../../containers/WorkkardDetail/actions/action";

const DateCell = (props) => {
  const { data, view, showMore,tooltip } = useSelector(
    (state) => ({
      data: state.diaries.view.data,
      view: state.diaries.view.view,
      showMore: state.diaries.view.showMore,
      tooltip : state.tooltip
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  let timeOut;

  const [sliceValue, setSliceValue] = useState(4);
  const [isExpanded, setExpanded] = useState(false);

  const showDetail = (target, Id, key) => {
    dispatch(
      fetchDiaryInfo({
        target: target,
        id: Id,
        key: key,
        position:props.position,
        isErrorScreen:false
      })
    );
  };

  useEffect(() => {
    if (props.dataKey.split(',')[1] == showMore.timeKey && view == 'day') {

      if (showMore.flag) {
        setExpanded(true);
        setSliceValue(props.data?.length);
      }
      else {
        setExpanded(false);
        setSliceValue(4);
      }
    }
  }, [showMore])

  const getDiarySponsors = () => {
    dispatch(getDiarySponsors());
  };

  const onMouseEnter = (e, Id, key) => {
    const targetRect = e.currentTarget.getBoundingClientRect();
    timeOut = setTimeout(()=>showDetail(targetRect, Id, key),500);
  };

  const onMouseLeave = () => {
    clearTimeout(timeOut);
  };

  return (
    <React.Fragment>
    <div className={`visiorData ${view=='day' ? 'noteData':''}`} onClick={props.onDateClick}>
      {/* render diaries here filtered according to date and time */}
      {/* {props.formattedDate ? <span className={props.dateClass}>{props.formattedDate}</span> : null} */}
      {props.data?.length > 0 &&
        (view == 'day'? props.data.slice(0, sliceValue) : props.data).map((item) => {
          return (
            <div
              key={item.Id}
              className={`${props.className} alignMiddle ${(item.Status === "CANCELLED")? 'visiorInactive':(item.IsCompleted ? 'completedCard visiorChecked':'visiorActive rowSpaceBetween')} 
                          pointer ${(tooltip.show && tooltip.childComponent && tooltip.childComponent.props.data && (tooltip.childComponent.props.data.TodoId == item.Id)) ? 'hover':''}`}
              onMouseEnter={(e) => onMouseEnter(e, item.Id, props.dataKey)}
              onMouseLeave={onMouseLeave}
              onClick={(e) => {
                clearTimeout(timeOut);
                dispatch(hideTooltip());
                if(item.Module == 'activity'){
                  dispatch(getActivityDetail({actId:item.ModuleId}))
                }
                else if(item.Module == 'workkard'){
                  dispatch(getWorkkardDetailMasterData({cId:item.ModuleId,doNotUpdateActivityListing:true}))
                }
                dispatch(
                  fetchDiaryInfo({
                    target: null,
                    id: item.Id,
                    key: props.dataKey,
                    isErrorScreen:false
                  })
                );
                dispatch(
                  showDialogueBox({
                    flag: true,
                    component: (
                      <DiaryDetailPopUp
                        dataKey={props.dataKey}
                        onClose={() => {
                          dispatch(hideDialogueBox());
                          dispatch(resetViewDiaryInfo());
                        }}
                      />
                    ),
                    overlayClassName: "modal",
                    contentClassName: "modalContent animated faster fadeInUpx2 medium detailModal",
                    shouldCloseOnOverlayClick: false,
                  })
                );
              }}
            >
              {(item.IsCompleted && item.Status!="CANCELLED") ? <Icons name="check" className="icon check mr" /> : null}
              <span className="cardWeekContent" data-test="diaryTitle">{item.Title}</span>
              {(item.Priorty == 3 && !item.IsCompleted && item.Status == "OPEN") && <Icons name="flag" className="icon" />}
            </div>
          );
        })}
     
    </div>
     {(props.data?.length > 4 && view == 'day') && (
        <div className={`trigger ${view == 'day' ? 'weekTrigger' : ''}`}
         onClick={() => {
          if (isExpanded) setSliceValue(4);
          else setSliceValue(props.data.length);
          setExpanded(!isExpanded);
            let temp = !isExpanded;
            dispatch(showMoreCalendarView({
              flag: temp,
              timeKey: props.dataKey.split(',')[1]
            }))
          }}> 
        {" "}
          {isExpanded ? <a className="pointer lessTrigger" data-test="showLess">Show Less</a> : <a className="pointer moreTrigger"
            data-test="showMore">{props.data.length - 4} More</a>}
      </div>
    )}
    </React.Fragment>
  );
};

export default DateCell;
